<template>
   <div class="nav">
       <ul class="navlist">
           <router-link :to='item.path'  tag="li" class="navitem" v-for='(item,index) in navlist' :key="index"><i></i> {{item.name}}</router-link>
       </ul>
       <router-link to='/' exact class="homebutton" tag="div" v-if="show"></router-link>
       <a exact class="backbutton" tag="div" v-if="!show" @click="back"></a>
   </div>
</template>

<script>
export default {
    props:{
        navlist:{
            required: true
        },
        show:{
            default: true
        }
    },
    data(){
        return{

        }
    },
    methods:{
        back(){
            this.$router.back()
        }
    }
}
</script>

<style>

</style>